/** Approximate marketing display; only 0 is exact. */
export function formatApproximateCompanyCount(count: number): string {
  if (count <= 0) return "0";
  if (count <= 5) return "1+"; // 1–5
  const band = Math.ceil(count / 10); // 6–10 → 5+, 11–20 → 15+, …
  return `${band * 10 - 5}+`;
}
